module.exports = __webpack_public_path__ + "img/sm.55745c73.svg";